import { render } from "./Settings-text--terms-and-conditions.vue?vue&type=template&id=499177f0"
import script from "./Settings-text--terms-and-conditions.vue?vue&type=script&lang=ts"
export * from "./Settings-text--terms-and-conditions.vue?vue&type=script&lang=ts"
script.render = render

export default script